import Vue from 'vue';
import BigNumber from 'bignumber.js';
export default Vue.extend({
    name: 'bonusAccrualWidget',
    data: () => {
        return {
            typeIndex: 0
        };
    },
    props: {
        loadError: {
            type: Boolean,
            required: false
        },
        isRetry: {
            type: Boolean,
            required: false
        },
        percentRebateBinance: {
            type: Number,
            required: true
        },
        paidCommissionBinance: {
            type: Number,
            required: true
        },
        okxData: {
            type: Object,
            required: true
        },
        okxDataError: {
            type: Boolean,
            required: true
        },
        faqPageUrl: {
            type: String
        }
    },
    computed: {
        faqPageTo() {
            const urlObj = new URL(this.faqPageUrl);
            return urlObj.pathname + urlObj.search + urlObj.hash;
        },
        percentToShow() {
            return this.currentType === 'okx' ? `${this.okxData.future}%` : `${this.percentRebateBinance}%`;
        },
        amountValueOKX() {
            return BigNumber(BigNumber(this.okxData.payment_sum).toFixed(2)).toFormat({
                decimalSeparator: ','
            });
        },
        paidCommissionBinanceFormatted() {
            return BigNumber(BigNumber(this.paidCommissionBinance).toFixed(2)).toFormat({
                decimalSeparator: ','
            });
        },
        title() {
            return this.$t('bonusesPage.widgets.fixedAccrualScale');
        },
        typeList() {
            return [this.$t('bonusesPage.widgets.binance'), this.$t('bonusesPage.widgets.okx')];
        },
        currentType() {
            return this.typeIndex === 0 ? 'binance' : 'okx';
        }
    }
});
